import { render, staticRenderFns } from "./copy2.vue?vue&type=template&id=55a6ed6e&scoped=true"
import script from "./copy2.vue?vue&type=script&lang=js"
export * from "./copy2.vue?vue&type=script&lang=js"
import style0 from "./copy2.vue?vue&type=style&index=0&id=55a6ed6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a6ed6e",
  null
  
)

export default component.exports